<app-card-widget title="State" subtitle="{{invoice.state.name}}" *ngIf="invoice$ | async as invoice">

  <div class="state invoice-status-type" [ngClass]="invoice.state.type">
    {{ invoice.state.name }}
  </div>

  <form [formGroup]="form" novalidate>

    <div class="card-section-container">
      <div class="card-section">
        <mat-form-field>
          <textarea matInput placeholder="Reason" formControlName="reason"></textarea>
        </mat-form-field>
      </div>
    </div>

  </form>

  <mat-nav-list *ngIf="showHistory">
    <mat-list-item *ngFor="let item of invoice.state_logs.slice().reverse()">
      <mat-icon matListIcon>done</mat-icon>
      <h3 matLine>{{ item.state.name }}</h3>
      <span matLine>{{ item.reason }}</span>
      <span matLine>{{ item.user?.name }}</span>
      <div class="list-item-timestamp">{{item.created_at | date:'short'}}</div>
    </mat-list-item>
  </mat-nav-list>

  <mat-card-actions align="end">
    <button type="button" mat-button (click)="toggleHistory()">{{ showHistory ? "Hide History" : "Show History" }}</button>
    <!-- AI: The wrapper span is load-bearing. A disabled mat-button does not emit
         pointer events, so matTooltip bound on the button itself never fires, and
         Material 14 has no disabledInteractive input (added in v18). Keep the
         tooltip on the wrapper. Spacing is unaffected because the margin rule
         `.mat-card-actions .mat-button` is a descendant selector.
         The === false / !== true comparisons are also deliberate: canReset$ emits
         nothing until the current user loads, so a plain ! would claim the
         permission is missing before it is known. The ngIf holds one object so
         all three bindings read a single subscription. Do not name that
         variable `reset` -- a template context variable shadows the component
         member of the same name inside the embedded view, which would break
         (click)="reset(invoice)".
         tabindex makes the wrapper focusable only while there is a message:
         a disabled button takes no focus, so without it the explanation is
         mouse-only and a keyboard user is left as stuck as the hidden button
         left them. -->
    <ng-container *ngIf="{ canReset: canReset$ | async } as resetGate">
      <span
        [matTooltip]="resetGate.canReset === false ? resetPermissionTooltip : ''"
        [attr.tabindex]="resetGate.canReset === false ? 0 : null">
        <button type="button" mat-button [disabled]="locked || !canReset(invoice) || resetGate.canReset !== true" (click)="reset(invoice)">Reset</button>
      </span>
    </ng-container>
    <!-- AI: Accept and Reject follow the Reset gate above on invoice:advance,
         with the same wrapper-span tooltip. Accept is also disabled while a
         financing hold applies in WaitingForFinancing or WaitingFinalPayment,
         and its tooltip then names the holds. Do not name the context
         variable `accept` or `reject`, for the reason given for Reset. -->
    <ng-container *ngIf="{ canAdvance: canAdvance$ | async } as advanceGate">
      <span
        class="reject-action"
        [matTooltip]="advanceGate.canAdvance === false ? advancePermissionTooltip : ''"
        [attr.tabindex]="advanceGate.canAdvance === false ? 0 : null">
        <button type="button" mat-button color="warn" [disabled]="locked || !canReject(invoice) || advanceGate.canAdvance !== true" (click)="reject(invoice)">Reject</button>
      </span>
      <span
        class="accept-action"
        [matTooltip]="acceptTooltip(invoice, advanceGate.canAdvance)"
        [attr.tabindex]="acceptTooltip(invoice, advanceGate.canAdvance) ? 0 : null">
        <button type="button" mat-button color="primary" [disabled]="locked || !canAccept(invoice) || advanceGate.canAdvance !== true || holdBlocksAccept(invoice)" (click)="accept(invoice)">Accept</button>
      </span>
    </ng-container>
  </mat-card-actions>

</app-card-widget>
